import { apiFetch } from "./client";

// Risposte del backend Task 4 (backend/app/qr_agenzia/agenzia_router.py e admin_router.py).
export interface QrAgenziaStato {
  attivo: boolean;
  link: string | null;
  /** null quando il conteggio via CRM non è riuscito (§5.2): la riga va nascosta, non a zero. */
  pratiche_mese: number | null;
  /** SVG del QR (anteprima del cartello, spec §3.2), null quando non attivo. */
  qr_svg: string | null;
}

export interface QrAgenziaRiga {
  espo_account_id: string;
  nome: string | null;
  attivo: boolean;
  link: string | null;
}

export interface QrAgenzieLista {
  interruttore: boolean;
  agenzie: QrAgenziaRiga[];
}

const AGENZIA_BASE = "/agenzia/qr";
const ADMIN_BASE = "/admin/qr-agenzie";

/** M7: scarica il PDF via fetch+blob (non un `<a href download>` diretto) così il
 * chiamante ha uno stato "in corso" osservabile e può disabilitare i pulsanti —
 * un doppio click altrimenti lanciava due render Chromium sul backend. Stesso
 * pattern di `downloadBollettaFile` (frontend/src/api/bollette.ts). */
async function scaricaCartelloPdf(formato: "A4" | "A5"): Promise<void> {
  const res = await fetch(`/api${AGENZIA_BASE}/cartello.pdf?formato=${formato}`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error("Errore download");
  const cd = res.headers.get("Content-Disposition");
  const filename = cd?.match(/filename="?([^"]+)"?/)?.[1] || `cartello-${formato}.pdf`;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Il cartello A4 come HTML, per l'anteprima in un iframe `srcdoc` (vedi QrSelfServiceClienti). */
async function cartelloHtml(): Promise<string> {
  const res = await fetch(`/api${AGENZIA_BASE}/cartello.html`, { credentials: "include" });
  if (!res.ok) throw new Error("Errore anteprima");
  return res.text();
}

export const qrAgenzieApi = {
  stato: () => apiFetch<QrAgenziaStato>(AGENZIA_BASE),
  cartelloHtml: cartelloHtml,
  scaricaCartelloPdf,

  lista: () => apiFetch<QrAgenzieLista>(ADMIN_BASE),
  interruttore: (acceso: boolean) =>
    apiFetch<{ acceso: boolean }>(`${ADMIN_BASE}/interruttore`, {
      method: "PUT",
      body: JSON.stringify({ acceso }),
    }),
  attiva: (acc: string) =>
    apiFetch<QrAgenziaRiga>(`${ADMIN_BASE}/${acc}/attiva`, { method: "POST" }),
  disattiva: (acc: string) =>
    apiFetch<QrAgenziaRiga>(`${ADMIN_BASE}/${acc}/disattiva`, { method: "POST" }),
  rifai: (acc: string) =>
    apiFetch<QrAgenziaRiga>(`${ADMIN_BASE}/${acc}/rifai`, { method: "POST" }),
};
